/*
    This module is intended to be used as the main data fetching library for developers.
    It abstracts away the axios instance and exposes responses and errors in an easy to 
    use way. Common headers such as 'Content-Type' are set here to.

    A lot of this is borrowed from:
    https://github.com/axios/axios/issues/320#issuecomment-219474269

    Usage for this module looks like:
    ```
        import {DataAccessService} from 'Core/api'

        const client = new DataAccessService()
        client.get('/users').then(users => {
            console.log(users)
            // Prints the list of users
        })
        client.post('/users',{
            firstName: 'Fred',
            lastName: 'Flintstone'
        }).then(users => {
            console.log(users)
            // Prints Prints [{firstName: 'Fred', lastName: 'Flintstone'}]
        }).catch(err => {})
        
        // You can also await this module too
        async function getUsers() {
            try {
                const client = new DataAccessService()
                const users = await client.get('/users')
                console.log(users)
                // Prints [{firstName: 'Fred', lastName: 'Flintstone'}]
            } catch (error) {
                console.error(error);
            }
        }
    ```

    Method signatures for the get, post, put, delete are the same as the similiarly named axios methods:
    https://github.com/axios/axios#instance-methods
*/
import AjaxService from './ajax-service';

export default class DataAccessService {
    constructor(options) {
        options = {
            ...options
        }
        this.axios = AjaxService;
        this.axios.defaults.baseURL = options.baseURL
    }
    request(method, url, data, params) {
        let options = {
            method: method,
            url: url,
            responseType: 'json'
        }

        options.params = params;
        if (data) {
            options.data = JSON.stringify(data);
        }
        options.headers = {
            'Content-Type': 'application/json',
            'Authorization': 'auth'
        };

        return new Promise((resolve, reject) => {
            this.axios.request(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    error.message = error.message || `${error.status} ${error.statusText}`;
                    reject(error);
                });
        });
    }
    get(url, data, params) {
        return this.request('GET', url, data, params);
    }
    post(url, data, params) {
        return this.request('POST', url, data, params);
    }
    put(url, data, params) {
        return this.request('PUT', url, data, params);
    }
    patch(url, data, params) {
        return this.request('PATCH', url, data, params);
    }
    delete(url, data, params) {
        return this.request('DELETE', url, data, params);
    }
}